import { render, staticRenderFns } from "./orderTimeUpdatePage.vue?vue&type=template&id=106e6b88&scoped=true"
import script from "./orderTimeUpdatePage.vue?vue&type=script&lang=js"
export * from "./orderTimeUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e6b88",
  null
  
)

export default component.exports